import * as React from 'react';
import SelectOptions from './SelectOptions';
import { SelectOption } from './formData';
import { Event } from '../../../../types';
import './SelectInput.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faAngleDown }  from '@fortawesome/fontawesome-free-solid';

interface Props {
    id: string;
    label: string;
    selection: string;
    options: SelectOption[];
    onSelect: Function;
}

interface State {
    value: string;
}

class SelectInput extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            value: props.selection
        };
    }

    handleChange(e: Event, id: string): void {
        const value = e.target.value;

        this.setState({
            value
        },            () => {
            this.props.onSelect(value, id);
        });
    }

    render() {
        const { label, options, id } = this.props;
        const { value } = this.state;

        return (
            <div className="select-input">
                <label className="select-input-label">
                    <span className="select-input-label-text">{label}</span>
                    <FontAwesomeIcon
                        icon={faAngleDown}
                        className="dropdown-caret"
                    />
                    <select
                        className="select-input-control"
                        value={value}
                        id={id}
                        onChange={(e) => this.handleChange(e, id)}
                    >
                        <SelectOptions options={options}/>
                    </select>
                </label>
            </div>
        );
    }
}

export default SelectInput;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/profile/SelectInput.tsx